import React from "react";
import { StringWidget } from "./StringWidget";

export function TranslatedTextWidget(props) {
  const { config, doAction} = props;

  const actionButtonOptions =
  {
    icon: 'font',
    action: async (value) => {
      await doAction(config.ActionId);
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="TranslatedTextWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}